export const elevation = {
  1: '0px 8px 16px 0px rgba(0, 14, 86, 0.16), 0px 2px 4px 0px rgba(0, 11, 114, 0.08);',
  2: '0px 2px 4px rgba(0, 11, 114, 0.08), 0px 8px 16px rgba(0, 14, 86, 0.16);',
  3: '0px 2px 4px rgba(0, 11, 114, 0.08), 0px 8px 16px rgba(0, 14, 86, 0.16)',
  4: '00px 8px 16px 0px rgba(0, 14, 86, 0.16), 0px 2px 4px 0px rgba(0, 11, 114, 0.08)',
  5: '0px 2px 4px 0px rgba(0, 11, 114, 0.08)',
};
